import { ProjectRouter } from './ProjectRouter';

export default ProjectRouter;
